module.exports = __webpack_public_path__ + "img/phone.b80b4025.png";